import { createFileRoute } from '@tanstack/react-router';
import { ResultsPane } from '../../../simops/-components/phase-views/ResultsPane';

export const Route = createFileRoute(
  '/_app/evaltool/$studyId/results/evidence',
)({
  component: () => <ResultsPane mode="evidence" />,
});
